import React, { Component } from 'react';
import Button from './Shared/Button';
import FormatText from '../Utils/TextFormatter';
import SurveyRect from './Shared/SurveyRect';
import ReactPlayer from 'react-player'

export default class VideoPage extends Component {
    state = {
        isVideoLoaded: false,
        stepEnded: false
    }
	render() {
        const {style, title, altButtonTitle, videoUrl, followingScreen} = this.props;
        const {isVideoLoaded, stepEnded} = this.state;
        const padding = 28;
        // const viemoUrl = `https://vimeo.com/66865270`

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";
        
        return <div style={style}>
            <SurveyRect {...this.props} H={440}>
                <div id="inner_surveyRect"  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
                    <div className="preface">{title}</div>
                    <div className="separation-bar"/>
                    {/* <div style={{
                        marginTop:8,
                        backgroundColor:'red',
                        display:'flex',
                        justifyItems:'center',
                        alignContent:'center',
                        // flex:1,
                        // width:100,
                        height:'37%'
                        // maxHeight: 440
                    }}> */}
                        <div style={{
                            position:'absolute',
                            top:100,
                            width:'100%',
                            height:'200px',
                            backgroundColor:'grey',
                            opacity: !isVideoLoaded ? 1 : 0,
                            transition: 'all 0.5s'
                        }}/>
                        {!stepEnded && <ReactPlayer url={videoUrl} playsinline onReady={() => {
                            // alert('READY')
                            setTimeout(() => {
                                this.setState({isVideoLoaded:true})
                            }, 500)
                            
                            // global.subLoader && global.subLoader()
                        }} controls pip={false} 
                        width="100%" 
                        height="200px"
                        // width="200px"
                        style={{
                            position:'absolute',
                            top:100,
                            // width:'100%',
                            // height:'200px',
                            // marginTop:-50,
                            // backgroundColor:'grey',
                            // height: 200,
                            opacity: isVideoLoaded ? 1 : 0,
                            transition: 'all 0.5s'
                        }} />}
                    {/* </div> */}
                    <div style={{
                        position:"absolute",
                        bottom:padding,
                        width:"100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Button style={{
                            position:"absolute",
                            left:0,
                            bottom:0,
                        }} text={buttonText} isActive={true} onClick={() => {
                            this.setState({stepEnded:true}, () => {
                                global.nextStage(followingScreen)
                            })
                        }}/>
                    </div>
                </div>
            </SurveyRect>
	  	</div>
	}
}




// WEBPACK FOOTER //
// ./src/Comp/VideoPage.js